const Theme = {
  body_background_color: 'linear-gradient(to bottom, #22AFAA, #E1E924) no-repeat fixed',
  title_font: 'Arial',
  text_font: 'Arial',
  logo_image_url: 'voyagedesiles.jpg',
  token_url: 'voyagedesiles.svg',
  number_hidden: true,
  header_full_height: true,
  header_no_margin: true,
  header_no_border: true,
  logo_full_width: true,
  button_border_width: 2,
  button_color: '#1D428A',
  button_hover_text_color: '#1D428A',
  button_radius: 100,
  button_outlined_border_color: '#1D428A',
  button_outlined_hover_border_color: '#1D428A'
}

export const voyagedesiles = {
  ...Theme,
}

export const voyagedesilesbleu = {
  ...Theme,
  body_background_color: '#1D428A',
  logo_image_url: 'voyagedesilesbleu.png',
  token_url: 'voyagedesilesbleu.png',
  button_radius: 10,
}
export default Theme
